import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import { AuthProvider, useAuth } from "./context/AuthContext";
import { InstitutionProvider } from "./context/InstitutionContext";
import { TenantConfigProvider } from "./context/TenantConfigContext";
import { ThemeProvider } from "./context/ThemeContext";
import TenantConfigAdmin from "./pages/TenantConfigAdmin";
import IntegrationsAdmin from "./pages/IntegrationsAdmin";
import IntegrationControlCenter from "./pages/IntegrationControlCenter";
import { LanguageProvider } from "./context/LanguageContext";

import ProtectedRoute from "./components/layout/ProtectedRoute";
import Shell from "./components/layout/Shell";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import InstitutionSetup from "./pages/InstitutionSetup";
import SetupStudio from "./pages/SetupStudio";
import SetupDomainDetail from "./pages/SetupDomainDetail";
import SetupGates from "./pages/SetupGates";
import SetupGateDetail from "./pages/SetupGateDetail";
import UATInbox from "./pages/UATInbox";
import UATFeedbackDetail from "./pages/UATFeedbackDetail";
import AcademicStructure from "./pages/AcademicStructure";
import UsersRoles from "./pages/UsersRoles";
import Settings from "./pages/Settings";
import ComingSoon from "./pages/ComingSoon";
import AIUseCases from "./pages/AIUseCases";
import ContentStudio from "./pages/ContentStudio";
import StudentAssistant from "./pages/StudentAssistant";
import Assessments from "./pages/Assessments";
import Psychometrics from "./pages/Psychometrics";
import Analytics from "./pages/Analytics";
import Workflows from "./pages/Workflows";
import Governance from "./pages/Governance";
import AdminGuide from "./pages/AdminGuide";
import ProductBrief from "./pages/ProductBrief";
import CommandCentre from "./pages/CommandCentre";
import ExecBriefing from "./pages/ExecBriefing";
import Onboarding from "./pages/Onboarding";
import ClarosAI from "./pages/ClarosAI";
import ClarosKnowledge from "./pages/ClarosKnowledge";
import ClarosCoreDashboard from "./pages/ClarosCoreDashboard";
import ClarosCoreStudents from "./pages/ClarosCoreStudents";
import StudentProfile from "./pages/StudentProfile";
import ClarosCoreNotices from "./pages/ClarosCoreNotices";
import ClarosCoreTimetable from "./pages/ClarosCoreTimetable";
import ClarosCoreFees from "./pages/ClarosCoreFees";
import FinanceOverview from "./pages/FinanceOverview";
import FinanceStudentAccounts from "./pages/FinanceStudentAccounts";
import FeeSetup from "./pages/FeeSetup";
import FeeScheduleDetail from "./pages/FeeScheduleDetail";
import FinanceAssessment from "./pages/FinanceAssessment";
import InvoiceManagement from "./pages/InvoiceManagement";
import StudentInvoices from "./pages/StudentInvoices";
import MyFinance from "./pages/MyFinance";
// FM4A
import ScholarshipsWaivers from "./pages/ScholarshipsWaivers";
import FM4ApprovalQueue from "./pages/FM4ApprovalQueue";
import ScholarshipWaiverAdmin from "./pages/ScholarshipWaiverAdmin";
import SponsorshipsAdmin from "./pages/SponsorshipsAdmin";
// FM4C
import ReimbursementsAdmin from "./pages/ReimbursementsAdmin";
// FM5: Refunds + Credits + Collections (BOUND-REOPEN-FM5-04)
import RefundsAdmin from "./pages/RefundsAdmin";
import CreditsAdmin from "./pages/CreditsAdmin";
import CollectionsWorkspace from "./pages/CollectionsWorkspace";
// PAY-01B: Manual Collections & Receipt Engine
import CashierWorkspace from "./pages/CashierWorkspace";
// PAY-UNIFIED-02: POS Reconciliation + Bank Reconciliation
import POSReconWorkspace from "./pages/POSReconWorkspace";
import BankReconWorkspace from "./pages/BankReconWorkspace";
// FM6: Finance Reports + Analytics (BOUND-REOPEN-FM6-01)
import FinanceReports from "./pages/FinanceReports";
// COA-01: Global COA Reference Browser (AOS-FIN-COA-GLOBAL-01)
import COABrowser from "./pages/COABrowser";
import COAActivation from "./pages/COAActivation";
import COASegments from "./pages/COASegments";
import COACombinations from "./pages/COACombinations";
// AOS-ALM-01 Phase 1: Adaptive Learning Module — Concept Taxonomy
import ALMConceptManager from "./pages/ALMConceptManager";
// AX1: Final Agentic Demo — Boardroom UI (BOUND-REOPEN-AX1-PKG2)
import AX1Demo from "./pages/AX1Demo";
import ModuleRegistry from "./pages/ModuleRegistry";
// PR1-D: Institution Onboarding Framework (AUTHORIZED 2026-09-14)
import InstitutionOnboarding from "./pages/InstitutionOnboarding";
// PHASE-1-ACAD: ISB Canonical Activation (AUTHORIZED 2026-02)
import AcademicOpsAdmin from "./pages/AcademicOpsAdmin";
import Gradebook from "./pages/Gradebook";
import AcademicStanding from "./pages/AcademicStanding";
import ClarosCoreAttendance from "./pages/ClarosCoreAttendance";
import ClarosCoreAttendanceReport from "./pages/ClarosCoreAttendanceReport";
import ClarosEnrollKanban from "./pages/ClarosEnrollKanban";
import ClarosEnrollLeadDetail from "./pages/ClarosEnrollLeadDetail";
import ClarosEnrollAnalytics from "./pages/ClarosEnrollAnalytics";
import AdmissionsApplications from "./pages/AdmissionsApplications";
import ApplicationDetail from "./pages/ApplicationDetail";
import ClarosComplyDashboard from "./pages/ClarosComplyDashboard";
import ClarosComplyCriterion from "./pages/ClarosComplyCriterion";
import ClarosComplyOBE from "./pages/ClarosComplyOBE";
import ClarosLaunchDashboard from "./pages/ClarosLaunchDashboard";
import ClarosLaunchDrives from "./pages/ClarosLaunchDrives";
import ClarosLaunchSkills from "./pages/ClarosLaunchSkills";
import ClarosLaunchInterview from "./pages/ClarosLaunchInterview";
import ClarosLaunchAdmin from "./pages/ClarosLaunchAdmin";
import ClarosInsightsDashboard from "./pages/ClarosInsightsDashboard";
import ClarosLearnHome from "./pages/ClarosLearnHome";
import ClarosLearnCourse from "./pages/ClarosLearnCourse";
import ClarosLearnContent from "./pages/ClarosLearnContent";
import ClarosLearnFaculty from "./pages/ClarosLearnFaculty";
import ClarosResearchHome from "./pages/ClarosResearchHome";
import ClarosPeopleHome from "./pages/ClarosPeopleHome";
import PeopleDirectory from "./pages/PeopleDirectory";
import EmploymentDetail from "./pages/EmploymentDetail";
import AttendanceLeave from "./pages/AttendanceLeave";
import WorkloadAssignments from "./pages/WorkloadAssignments";
import PendingApprovals from "./pages/PendingApprovals";
import IdentityManagement from "./pages/IdentityManagement";
import MySelfService from "./pages/MySelfService";
import ClarosAlumniHome from "./pages/ClarosAlumniHome";
import ClarosSafeHome from "./pages/ClarosSafeHome";
import ClarosGreenHome from "./pages/ClarosGreenHome";
import CampusOverview from "./pages/CampusOverview";
import DigitalIDCard from "./pages/DigitalIDCard";
import VerifyCard from "./pages/VerifyCard";
import PhotoReviewQueue from "./pages/PhotoReviewQueue";
import HostelDashboard from "./pages/HostelDashboard";
import HostelGLJournals from "./pages/HostelGLJournals";
import HostelRoomInventory from "./pages/HostelRoomInventory";
import HostelRateMaster from "./pages/HostelRateMaster";
import HostelBookingList from "./pages/HostelBookingList";
import HostelNewBooking from "./pages/HostelNewBooking";
import HostelBookingDetail from "./pages/HostelBookingDetail";
import PaymentPortal, { PaymentHistory } from "./pages/PaymentPortal";
import PaymentStatus from "./pages/PaymentStatus";
import StatutoryOverview from "./pages/StatutoryOverview";
import StatutoryRegimeAssignment from "./pages/StatutoryRegimeAssignment";
import StatutoryEligibility from "./pages/StatutoryEligibility";
import StatutoryEvidence from "./pages/StatutoryEvidence";
import StatutoryRuleVersions from "./pages/StatutoryRuleVersions";
import StatutoryAuditLog from "./pages/StatutoryAuditLog";
import StatutoryOpenQuestions from "./pages/StatutoryOpenQuestions";
import StatutoryReadinessMatrix from "./pages/StatutoryReadinessMatrix";
import { StatutoryProvider } from "./components/statutory/StatutoryContext";
import AuthCallback from "./pages/AuthCallback";
import ModuleGate from "./components/layout/ModuleGate";
import EnrollmentOfferings from "./pages/EnrollmentOfferings";
import EnrollmentImport from "./pages/EnrollmentImport";
// PHASE-2A-4: Assessment Design Workspace (AUTHORIZED 2026-02)
import AssessmentDesign from "./pages/AssessmentDesign";
import AssessmentDesignPolicies from "./pages/AssessmentDesignPolicies";
import AssessmentDesignSchemes from "./pages/AssessmentDesignSchemes";
import AssessmentDesignBlueprints from "./pages/AssessmentDesignBlueprints";
import AssessmentDesignItemBanks from "./pages/AssessmentDesignItemBanks";
import AssessmentDesignRubrics from "./pages/AssessmentDesignRubrics";
import AssessmentDesignOutcomes from "./pages/AssessmentDesignOutcomes";
// PHASE-2B: Assessment Delivery & Attempt (AUTHORIZED 2026-02)
import AssessmentDelivery from "./pages/AssessmentDelivery";
import OfferingDetail from "./pages/OfferingDetail";
import DeliveryRegistrations from "./pages/DeliveryRegistrations";
import DeliveryVenues from "./pages/DeliveryVenues";
import MyExams from "./pages/MyExams";
import AttemptWorkspace from "./pages/AttemptWorkspace";
import DeliveryAdminRoute from "./components/layout/DeliveryAdminRoute";
// PHASE-2C: Assessment Evaluation (AUTHORIZED 2026-02)
import EvaluationOverview from "./pages/EvaluationOverview";
import MarkerAllocation from "./pages/MarkerAllocation";
import EvaluationMarking from "./pages/EvaluationMarking";
import MarkingWorkspace from "./pages/MarkingWorkspace";
import EvaluationModeration from "./pages/EvaluationModeration";
import ModerationWorkspace from "./pages/ModerationWorkspace";
import EvaluationNormalization from "./pages/EvaluationNormalization";
import EvaluationRatification from "./pages/EvaluationRatification";
import EvaluationGradebook from "./pages/EvaluationGradebook";

import { UATFeedbackButton } from "./components/uat/UATFeedbackButton";

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

/** FM1: /core/fees compatibility redirect.
 * Staff → /finance/overview, Student → /my-finance.
 * ClarosCoreFees.jsx is no longer an active product after FM1 cutover.
 */
function CoreFeesRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "student") return <Navigate to="/my-finance" replace />;
  return <Navigate to="/finance/overview" replace />;
}

function FinanceRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "student") return <Navigate to="/my-finance" replace />;
  return <Navigate to="/finance/overview" replace />;
}

function ShellRoutes() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/setup" element={<SetupStudio />} />
        <Route path="/setup/module-registry" element={<ModuleRegistry />} />
        <Route path="/setup/domains/:domainId" element={<SetupDomainDetail />} />
        <Route path="/setup/gates" element={<SetupGates />} />
        <Route path="/setup/gates/:gateId" element={<SetupGateDetail />} />
        <Route path="/setup/uat-inbox" element={<UATInbox />} />
        <Route path="/setup/uat-inbox/:feedbackId" element={<UATFeedbackDetail />} />
        <Route path="/institution-setup" element={<InstitutionSetup />} />
        <Route path="/academic-structure" element={<ModuleGate module="02.01"><AcademicStructure /></ModuleGate>} />
        <Route path="/users-roles" element={<UsersRoles />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/ai-use-cases" element={<AIUseCases />} />
        <Route path="/content-studio" element={<ModuleGate module="03.01"><ContentStudio /></ModuleGate>} />
        <Route path="/student-assistant" element={<ModuleGate module="01.06"><StudentAssistant /></ModuleGate>} />
        <Route path="/ai" element={<ModuleGate module="10.05"><ClarosAI /></ModuleGate>} />
        <Route path="/ai/knowledge" element={<ModuleGate module="10.05"><ClarosKnowledge /></ModuleGate>} />
        <Route path="/core/dashboard" element={<ModuleGate module="01.02"><ClarosCoreDashboard /></ModuleGate>} />
        <Route path="/core/students" element={<ModuleGate module="01.02"><ClarosCoreStudents /></ModuleGate>} />
        <Route path="/core/students/:studentId" element={<ModuleGate module="01.02"><StudentProfile /></ModuleGate>} />
        <Route path="/core/notices" element={<ModuleGate module="01.02"><ClarosCoreNotices /></ModuleGate>} />
        <Route path="/core/timetable" element={<ModuleGate module="02.04"><ClarosCoreTimetable /></ModuleGate>} />
        {/* FM1: /core/fees compatibility redirect (legacy route — no longer an active product) */}
        <Route path="/core/fees" element={<ModuleGate module="05.01"><CoreFeesRedirect /></ModuleGate>} />
        {/* FM1: Finance Experience Foundation — Staff routes */}
        <Route path="/finance" element={<FinanceRedirect />} />
        <Route path="/finance/overview" element={<ModuleGate module="05.01"><FinanceOverview /></ModuleGate>} />
        <Route path="/finance/accounts" element={<ModuleGate module="05.01"><FinanceStudentAccounts /></ModuleGate>} />
        {/* FM2: Fee Setup + Rules + Admin Configuration */}
        <Route path="/finance/fee-setup" element={<ModuleGate module="05.01"><FeeSetup /></ModuleGate>} />
        <Route path="/finance/fee-setup/:scheduleId" element={<ModuleGate module="05.01"><FeeScheduleDetail /></ModuleGate>} />
        {/* FM3P: Finance Assessment Authorization */}
        <Route path="/finance/assessments" element={<ModuleGate module="05.01"><FinanceAssessment /></ModuleGate>} />
        {/* FM3: Invoices + Installments + Payments + Receipts */}
        <Route path="/finance/invoices" element={<ModuleGate module="05.01"><InvoiceManagement /></ModuleGate>} />
        {/* FM3F: Student own invoices */}
        <Route path="/student/invoices" element={<ModuleGate module="05.01"><StudentInvoices /></ModuleGate>} />
        {/* FM1: Student My Finance — own-finance isolation proven (FM1-G1) */}
        <Route path="/my-finance" element={<ModuleGate module="05.01"><MyFinance /></ModuleGate>} />
        {/* FM4A: Scholarships + Waivers Core (authorized 2026-09-13) */}
        <Route path="/finance/scholarships-waivers" element={<ModuleGate module="05.01"><ScholarshipsWaivers /></ModuleGate>} />
        <Route path="/finance/approval-queue" element={<ModuleGate module="05.01"><FM4ApprovalQueue /></ModuleGate>} />
        <Route path="/finance/admin/scholarships-waivers" element={<ModuleGate module="05.01"><ScholarshipWaiverAdmin /></ModuleGate>} />
        <Route path="/finance/sponsorships" element={<ModuleGate module="05.01"><SponsorshipsAdmin /></ModuleGate>} />
        {/* FM4C: Reimbursements Core */}
        <Route path="/finance/reimbursements" element={<ModuleGate module="05.01"><ReimbursementsAdmin /></ModuleGate>} />
        {/* FM5: Refunds + Credits + Collections (BOUND-REOPEN-FM5-04) */}
        <Route path="/finance/refunds" element={<ModuleGate module="05.03"><RefundsAdmin /></ModuleGate>} />
        <Route path="/finance/credits" element={<ModuleGate module="05.03"><CreditsAdmin /></ModuleGate>} />
        <Route path="/finance/collections" element={<ModuleGate module="05.03"><CollectionsWorkspace /></ModuleGate>} />
        {/* PAY-01B: Manual Collections & Receipt Engine */}
        <Route path="/finance/cashier" element={<ModuleGate module="05.01"><CashierWorkspace /></ModuleGate>} />
        {/* PAY-UNIFIED-02: POS + Bank Reconciliation */}
        <Route path="/finance/pos-recon" element={<ModuleGate module="05.01"><POSReconWorkspace /></ModuleGate>} />
        <Route path="/finance/bank-recon" element={<ModuleGate module="05.01"><BankReconWorkspace /></ModuleGate>} />
        {/* FM6: Finance Reports + Analytics (BOUND-REOPEN-FM6-01) */}
        <Route path="/finance/reports" element={<ModuleGate module="05.04"><FinanceReports /></ModuleGate>} />
        {/* COA-01: Global COA Reference Browser (AOS-FIN-COA-GLOBAL-01)
            Platform-global resource — no ModuleGate; COABrowser has its own RBAC. */}
        <Route path="/finance/coa/reference" element={<COABrowser />} />
        <Route path="/finance/coa/activations" element={<COAActivation />} />
        <Route path="/finance/coa/segments" element={<COASegments />} />
        <Route path="/finance/coa/combinations" element={<COACombinations />} />
        {/* AOS-ALM-01 Phase 1: Concept Taxonomy (institution-scoped, RBAC in routes_alm.py) */}
        <Route path="/alm/concepts" element={<ALMConceptManager />} />
        {/* AX1: Finance Remediation Agent Demo (BOUND-REOPEN-AX1-PKG2) */}
        <Route path="/ax1-demo" element={<AX1Demo />} />
        <Route path="/core/attendance" element={<ModuleGate module="03.03"><ClarosCoreAttendance /></ModuleGate>} />
        <Route path="/core/attendance/report" element={<ModuleGate module="03.03"><ClarosCoreAttendanceReport /></ModuleGate>} />
        <Route path="/enroll" element={<ModuleGate module="01.01"><ClarosEnrollKanban /></ModuleGate>} />
        <Route path="/enroll/analytics" element={<ModuleGate module="01.01"><ClarosEnrollAnalytics /></ModuleGate>} />
        <Route path="/enroll/leads/:id" element={<ModuleGate module="01.01"><ClarosEnrollLeadDetail /></ModuleGate>} />
        <Route path="/admissions/applications" element={<ModuleGate module="01.01"><AdmissionsApplications /></ModuleGate>} />
        <Route path="/admissions/applications/:applicationId" element={<ModuleGate module="01.01"><ApplicationDetail /></ModuleGate>} />
        <Route path="/comply" element={<ModuleGate module="09.01"><ClarosComplyDashboard /></ModuleGate>} />
        <Route path="/comply/criteria/:id" element={<ModuleGate module="09.01"><ClarosComplyCriterion /></ModuleGate>} />
        <Route path="/comply/obe" element={<ModuleGate module="09.01"><ClarosComplyOBE /></ModuleGate>} />
        <Route path="/launch" element={<ModuleGate module="01.06"><ClarosLaunchDashboard /></ModuleGate>} />
        <Route path="/launch/drives" element={<ModuleGate module="01.06"><ClarosLaunchDrives /></ModuleGate>} />
        <Route path="/launch/skills" element={<ModuleGate module="01.06"><ClarosLaunchSkills /></ModuleGate>} />
        <Route path="/launch/interview" element={<ModuleGate module="01.06"><ClarosLaunchInterview /></ModuleGate>} />
        <Route path="/launch/admin" element={<ModuleGate module="01.06"><ClarosLaunchAdmin /></ModuleGate>} />
        <Route path="/insights" element={<ModuleGate module="10.01"><ClarosInsightsDashboard /></ModuleGate>} />
        <Route path="/learn" element={<ModuleGate module="03.01"><ClarosLearnHome /></ModuleGate>} />
        <Route path="/learn/courses/:courseId" element={<ModuleGate module="03.01"><ClarosLearnCourse /></ModuleGate>} />
        <Route path="/learn/courses/:courseId/content/:contentId" element={<ModuleGate module="03.01"><ClarosLearnContent /></ModuleGate>} />
        <Route path="/learn/faculty/:courseId" element={<ModuleGate module="03.01"><ClarosLearnFaculty /></ModuleGate>} />
        <Route path="/research" element={<ModuleGate module="07.01"><ClarosResearchHome /></ModuleGate>} />
        <Route path="/people" element={<ModuleGate module="06.01"><ClarosPeopleHome /></ModuleGate>} />
        <Route path="/people/employment" element={<PeopleDirectory />} />
        <Route path="/people/employment/:workerId" element={<EmploymentDetail />} />
        <Route path="/people/attendance-leave" element={<AttendanceLeave />} />
        <Route path="/people/workload" element={<WorkloadAssignments />} />
        {/* AOS-PEO-03: Employee Self-Service, Pending Approvals, Identity Management */}
        <Route path="/people/approvals" element={<PendingApprovals />} />
        <Route path="/people/identity" element={<IdentityManagement />} />
        <Route path="/people/self-service" element={<MySelfService />} />
        <Route path="/alumni-network" element={<ModuleGate module="01.06"><ClarosAlumniHome /></ModuleGate>} />
        <Route path="/safe" element={<ModuleGate module="08.03"><ClarosSafeHome /></ModuleGate>} />
        <Route path="/green" element={<ModuleGate module="08.03"><ClarosGreenHome /></ModuleGate>} />
        {/* AOS-CAMPUS-DEMO-02 — Campus Services (Domain 5) */}
        <Route path="/campus/overview" element={<CampusOverview />} />
        {/* CAMP-RES-DEMO-01 — Hostel Management (Module 08.02) */}
        <Route path="/campus/hostel" element={<HostelDashboard />} />
        <Route path="/campus/hostel/rooms" element={<HostelRoomInventory />} />
        <Route path="/campus/hostel/rates" element={<HostelRateMaster />} />
        <Route path="/campus/hostel/bookings" element={<HostelBookingList />} />
        <Route path="/campus/hostel/bookings/new" element={<HostelNewBooking />} />
        <Route path="/campus/hostel/bookings/:id" element={<HostelBookingDetail />} />
        <Route path="/campus/hostel/gl/journals" element={<HostelGLJournals />} />
        {/* PAY-UNIFIED-01: Student-facing payment portal (AOS-PAY-UNIFIED-01 Phase 01) */}
        <Route path="/campus/pay" element={<PaymentPortal />} />
        <Route path="/campus/pay/status/:intentId" element={<PaymentStatus />} />
        <Route path="/campus/pay/history" element={<PaymentHistory />} />
        <Route path="/admin/tenant-config" element={<TenantConfigAdmin />} />
        {/* FM7: Integration & AI Enablement Foundation (BOUND-REOPEN-FM7-01) */}
        <Route path="/admin/integrations" element={<IntegrationsAdmin />} />
        {/* AOS-PAY-UNIFIED-03A: Integration Control Center */}
        <Route path="/finance/integrations/control-center" element={<ModuleGate module="05.01"><IntegrationControlCenter /></ModuleGate>} />
        {/* PR1-D: Institution Onboarding Framework (BOUND-REOPEN-PR1-04) */}
        <Route path="/admin/institution-onboarding" element={<InstitutionOnboarding />} />
        {/* PHASE-1-ACAD: ISB Canonical Activation & Delivery Spine (AUTHORIZED 2026-02) */}
        <Route path="/admin/academic-setup" element={<AcademicOpsAdmin />} />
        <Route path="/gradebook" element={<Gradebook />} />
        <Route path="/academic-standing" element={<AcademicStanding />} />
        <Route path="/assessments" element={<ModuleGate module="04.01"><Assessments /></ModuleGate>} />
        <Route path="/psychometrics" element={<Psychometrics />} />
        <Route path="/analytics" element={<ModuleGate module="10.01"><Analytics /></ModuleGate>} />
        <Route path="/workflows" element={<Workflows />} />
        <Route path="/governance" element={<Governance />} />
        <Route path="/admin-guide" element={<AdminGuide />} />
        <Route path="/product-brief" element={<ProductBrief />} />
        <Route path="/command" element={<ModuleGate module="10.03"><CommandCentre /></ModuleGate>} />
        <Route path="/exec-briefing" element={<ExecBriefing />} />
        <Route path="/onboarding" element={<Onboarding />} />
        {/* W11-L Statutory Configuration — Frontend Prototype Only */}
        <Route path="/statutory/overview" element={<StatutoryProvider><StatutoryOverview /></StatutoryProvider>} />
        <Route path="/statutory/regime-assignment" element={<StatutoryProvider><StatutoryRegimeAssignment /></StatutoryProvider>} />
        <Route path="/statutory/eligibility" element={<StatutoryProvider><StatutoryEligibility /></StatutoryProvider>} />
        <Route path="/statutory/evidence" element={<StatutoryProvider><StatutoryEvidence /></StatutoryProvider>} />
        <Route path="/statutory/rule-versions" element={<StatutoryProvider><StatutoryRuleVersions /></StatutoryProvider>} />
        <Route path="/statutory/audit" element={<StatutoryProvider><StatutoryAuditLog /></StatutoryProvider>} />
        <Route path="/statutory/open-questions" element={<StatutoryProvider><StatutoryOpenQuestions /></StatutoryProvider>} />
        <Route path="/statutory/readiness-matrix" element={<StatutoryProvider><StatutoryReadinessMatrix /></StatutoryProvider>} />
        {/* PHASE-2A-4: Assessment Design Workspace — Teaching & Learning */}
        <Route path="/assessment-design" element={<AssessmentDesign />} />
        <Route path="/assessment-design/policies" element={<AssessmentDesignPolicies />} />
        <Route path="/assessment-design/schemes" element={<AssessmentDesignSchemes />} />
        <Route path="/assessment-design/blueprints" element={<AssessmentDesignBlueprints />} />
        <Route path="/assessment-design/item-banks" element={<AssessmentDesignItemBanks />} />
        <Route path="/assessment-design/rubrics" element={<AssessmentDesignRubrics />} />
        <Route path="/assessment-design/outcomes" element={<AssessmentDesignOutcomes />} />
        {/* PHASE-2B: Assessment Delivery — admin routes (route-level auth enforced) */}
        <Route path="/assessment-delivery" element={<DeliveryAdminRoute><AssessmentDelivery /></DeliveryAdminRoute>} />
        <Route path="/assessment-delivery/offerings/:id" element={<DeliveryAdminRoute><OfferingDetail /></DeliveryAdminRoute>} />
        <Route path="/assessment-delivery/registrations" element={<DeliveryAdminRoute><DeliveryRegistrations /></DeliveryAdminRoute>} />
        <Route path="/assessment-delivery/venues" element={<DeliveryAdminRoute><DeliveryVenues /></DeliveryAdminRoute>} />
        {/* PHASE-2B: Student exam portal — auth enforced by backend ownership checks */}
        <Route path="/my-exams" element={<MyExams />} />
        <Route path="/my-exams/attempt/:attemptId" element={<AttemptWorkspace />} />
        {/* PHASE-2C: Assessment Evaluation & Scoring (C1–C6) */}
        <Route path="/assessment-evaluation" element={<EvaluationOverview />} />
        <Route path="/assessment-evaluation/marker-allocation" element={<MarkerAllocation />} />
        <Route path="/assessment-evaluation/marking" element={<EvaluationMarking />} />
        <Route path="/assessment-evaluation/marking/:caseId" element={<MarkingWorkspace />} />
        <Route path="/assessment-evaluation/moderation" element={<EvaluationModeration />} />
        <Route path="/assessment-evaluation/moderation/:caseId" element={<ModerationWorkspace />} />
        <Route path="/assessment-evaluation/normalization" element={<EvaluationNormalization />} />
        <Route path="/assessment-evaluation/ratification" element={<EvaluationRatification />} />
        <Route path="/assessment-evaluation/gradebook" element={<EvaluationGradebook />} />
        {/* AOS-LID-01: Student Digital ID Card */}
        <Route path="/my-id" element={<ModuleGate module="08.12"><DigitalIDCard /></ModuleGate>} />
        {/* AOS-LID-02: Staff Campus ID Verification */}
        <Route path="/campus/verify" element={<ModuleGate module="08.12"><VerifyCard /></ModuleGate>} />
        {/* AOS-LID-03: Staff Photo Review Queue */}
        <Route path="/campus/photos" element={<ModuleGate module="08.12"><PhotoReviewQueue /></ModuleGate>} />
        {/* ENR1A — Program Offering administration */}
        <Route path="/enrollment/offerings" element={<EnrollmentOfferings />} />
        {/* ENR1B-G — Import pipeline (upload, dry-run, commit, history) */}
        <Route path="/enrollment/import" element={<EnrollmentImport />} />
        <Route path="*" element={<Navigate to="/" replace />} />} />
      </Routes>
    </Shell>
  );
}

export default function App() {
  // Synchronously detect OAuth callback BEFORE ProtectedRoute runs.
  // Emergent OAuth returns the user to {redirect}#session_id=...
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return (
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <LanguageProvider>
              <InstitutionProvider>
                <TenantConfigProvider>
                  <AuthCallback />
                  <Toaster position="top-right" richColors />
                </TenantConfigProvider>
              </InstitutionProvider>
            </LanguageProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    );
  }
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <LanguageProvider>
            <InstitutionProvider>
              <TenantConfigProvider>
              <Routes>
                <Route path="/login" element={<LoginRoute />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <ShellRoutes />
                    </ProtectedRoute>
                  }
                />
              </Routes>
              <UATFeedbackButton />
              <Toaster position="top-right" richColors />
              </TenantConfigProvider>
            </InstitutionProvider>
          </LanguageProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
